import React from 'react';

import {
  BetStatus,
  convertAmount,
  exchangeAmountByRate,
  ListElemImage,
  ListElemText,
  ListItem,
  ListItemCell,
  ListItemCont,
  maskName,
} from '@pascal/pascal-core';
import { candiesByIndex, TranslationKeys } from '../../../enums';

const OtherBets = ({ t, data }) => {
  return (
    <>
      {data.betData.map((betData) => {
        return (
          <ListItemCont
            key={`${data.id}_${betData.candy}`}
            forRemove={data.status !== BetStatus.Pending}
            animationDelayInSeconds={1.4}
          >
            <ListItem active={betData.winAmount}>
              <ListItemCell>
                <ListElemText>
                  {maskName(data?.userId < 0 ? Math.abs(data?.userId) : data.playerExternalId)}
                </ListElemText>
              </ListItemCell>
              <ListItemCell>
                <ListElemImage imageSrc={candiesByIndex[betData.candy]} alt='candy' />
              </ListItemCell>
              <ListItemCell>
                <ListElemText>
                  {data.freeBetId
                    ? t(TranslationKeys.FreeBet)
                    : convertAmount(
                        exchangeAmountByRate({
                          ...data,
                          ...betData,
                        }).amount
                      )}
                </ListElemText>
              </ListItemCell>
              <ListItemCell>
                <ListElemText>
                  {/* eslint-disable-next-line no-nested-ternary */}
                  {data.status === BetStatus.Pending
                    ? '...'
                    : convertAmount(
                        exchangeAmountByRate({
                          ...data,
                          ...betData,
                        }).winAmount
                      )}
                </ListElemText>
              </ListItemCell>
            </ListItem>
          </ListItemCont>
        );
      })}
    </>
  );
};

export default OtherBets;
